// src/data/languages/yoruba/categories/index.ts
import { CategoryDictionary } from '../../../../types/types';

import salutations from './salutations';
import {nombres} from './nombres';
import {temps} from './temps';
import {animaux} from './animaux';
import {famille} from './famille';
import {nourriture} from './nourritures';
import {couleurs} from './couleurs';
import {corps} from './corps';
import {verbes} from './verbes';
import {objets} from './objets';
import {grammaire} from './grammaire';

// L'alphabet est la première étape du parcours (comme pour le copte) :
// on le sort de la grammaire pour qu'il n'y apparaisse pas une seconde fois.
const { 'Alphabet yoruba': alphabet, ...grammaireSansAlphabet } = grammaire as Record<string, any>;

export const categories: CategoryDictionary = {
  'Alphabet yoruba': alphabet,
  'Salutations et expressions courantes': salutations,
  'Nombres': nombres,
  'Temps': temps,
  'Animaux': animaux,
  'Famille': famille,
  'Nourriture': nourriture,
  'Couleurs': couleurs,
  'Corps': corps,
  'Verbes': verbes,
  'Objets du quotidien': objets,
  'Grammaire': grammaireSansAlphabet
};

export default categories;
